import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`v1/api/partner/partners?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`v1/api/partner/partners/${id}`, { params });
}

export async function create(body) {
  return request(`v1/api/partner/partners`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`v1/api/partner/partners/${id}`, {
    method: 'POST',
    body,
  });
}
export async function sync(body) {
  return request(`/partner/sync-partners`, {
    method: 'POST',
    body,
  });
}

export async function pullVoucher(body) {
  return request(`/partner/pull-voucher`, {
    method: 'POST',
    body,
  });
}


export async function resetPartnerField(id, field){
  return request(`/partner/partners/${id}/reset`, {
    method: 'POST',
    body: {
      reset_fields: field,
    }
  });
}

export async function resetStoreField(id, field){
  return request(`/partner/stores/${id}/reset`, {
    method: 'POST',
    body: {
      reset_fields: field,
    }
  });
}